<template lang="pug">
.message-center-container
  .header
    span 消息中心
    img.close-btn(src='@/assets/imgs/vip/ic_close.png' @click='closeMessageCenter')
  ul.message-list(v-if="messageList.length", ref="list")
    li.message-item-container
      MessageItem(
        v-for="item in messageList",
        :key="item.id",
        :data="item",
      )
  .message-empty(v-else-if="!loading")
    img(src="@/assets/imgs/vip/message_empty.png")
    .message-empty-text.color_text_1 暂无消息
</template>

<script>
import service from '@/service/vip/index';
import v3 from '@/util/v3';
import MessageItem from './MessageItem.vue';

export default {
  name: 'MessageCenter',
  data() {
    return {
      messageList: [],
      secretKey: 'TphDcvmBvc12dzla',
      loading: true,
    };
  },
  components: {
    MessageItem,
  },
  mounted() {
    this.getMessageList();
  },
  watch: {
    messageList() {
      this.$nextTick(() => {
        this.updateScroll();
      });
    },
  },
  methods: {
    closeMessageCenter() {
      this.$emit('closeMessageCenter');
    },
    async getMessageList() {
      try {
        const { svip, vip } = await this.getVipStatus();
        const keyid = 'dict-message-center';
        const requestData = {
          app: 'deskdict_bkd',
          type: 'msg',
          userType: svip || vip ? 'vip' : 'nonVip',
        };
        const v3Param = v3.genParamV3(
          {},
          this.secretKey,
          keyid,
          'web',
          'webdict',
          '1',
          '1',
          'web',
          '',
          '',
          '',
          '',
          '1',
        );
        const res = await service.getMessageList({
          ...v3Param,
          ...requestData,
        });

        let messageAccounts = [];
        if (!res.list.length) {
          this.messageList = [];
          return;
        } else {
          messageAccounts = res.list;
        }
        // 获取消息详情并将消息标记为已读
        for (let i = 0; i < messageAccounts.length; ++i) {
          const { accountId, accountName } = messageAccounts[i];
          // eslint-disable-next-line
          const detail = await service.getMessageDetail({
            ...v3Param,
            ...requestData,
            accountId,
            pageSize: 100,
          });
          this.messageList = this.messageList.concat(
            detail.list.map((item) => ({
              ...item,
              accountName,
            })),
          );
          // 标记为已读
          if (messageAccounts[i].unReadCount) {
            this.setRead(accountId, v3Param);
          }
        }
      } catch (e) {
        console.log(e);
        this.messageList = [];
      } finally {
        this.loading = false;
      }
    },
    setRead(id, v3Params) {
      service
        .setMessageRead({
          ...v3Params,
          app: 'deskdict_bkd',
          type: 'msg',
          accountId: id,
        })
        .catch((e) => {
          console.log('已读消息失败', e);
        });
    },
    getClientInfo() {
      return new Promise((resolve, reject) => {
        window.ydk.getClientInfo({
          success: (res) => {
            resolve(res);
          },
          fail: (err) => {
            reject(err);
          },
        });
      });
    },
    async getVipStatus() {
      const param = {
        imei: '1',
        keyfrom: 'webdict',
        apiversion: '1.0',
        product: 'web',
      };
      try {
        const res = await service.getVipStatus(param);
        return res;
      } catch (e) {
        return {
          svip: false,
          vip: false,
        };
      }
    },
    updateScroll() {
      const { list } = this.$refs;
      if (!list) return;
      // if (list.scrollHeight > list.clientHeight) {
      //   list.scrollTop = 0;
      //   list.style.paddingRight = '10px';
      // } else {
      //   list.style.paddingRight = '20px';
      // }
      list.style.paddingRight = '20px';
    },
  },
};
</script>

<style lang="stylus" scoped>
.message-center-container
  width: 290px;
  height: 453px;
  position fixed
  top 50%
  transform translate(-50%,-50%)
  left 50%
  z-index 99
  overflow: hidden
  border-radius: 7px;
  .header
    height 20px
    padding 10px 17px 10px 20px
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    color: #2A2B2E;
    background: #FAFAFC
    position relative
    .close-btn
      position absolute
      right 17px
      top 10px
      width 16px
      height 16px
      cursor pointer
  .message-list
    width: 100%;
    height: calc(100% - 40px);
    overflow: auto;
    padding: 20px 20px 0 20px;
    box-sizing: border-box;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
    overflow: -moz-scrollbars-none; /* Firefox */
    &::-webkit-scrollbar
      -webkit-appearance: none;
      width: 10px;
      height: 12px;
      background: transparent;
    &::-webkit-scrollbar-thumb
      min-height: 50px;
      border-radius: 20px;
      border: 3px solid rgba(255, 255, 255, 0);
      background-clip: content-box;
    &::-webkit-scrollbar-corner
      background: transparent;
    &::-webkit-scrollbar-button
      height: 0;
      width: 0;
  .message-empty
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    img
      width: 150px;
      height: 135px;
      margin-bottom: 4px;
      margin-top: 96px;
    .message-empty-text
      font-size: 14px;
      line-height: 14px;

.light
  .message-center-container
    background: #ffffff;
    .message-list
      &::-webkit-scrollbar-thumb
        background-color: #c8c9cc;
      &::-webkit-scrollbar-thumb:hover
        background-color: #a8aaad;
</style>
